<template>
  <div>
    <div
      v-if="userCanEdit && saving === false"
      style="margin-top: -50px;"  class="text-right mb-3">
      <div v-if="mode === 'normal'">
        <button
          type="button"
          class="btn btn-primary text-white"
          @click="switchMode('edit')">
          Редактировать
        </button>
      </div>
      <div v-if="mode === 'edit'">
        <button
          type="button"
          class="btn btn-default text-primary"
          @click="switchMode('normal')">
          Отменить
        </button>
        <button
          type="button"
          class="btn btn-primary text-white"
          @click="saveChanges()">
          Сохранить
        </button>
      </div>
    </div>

    <div class="border-top border-left border-right">
      <div class="pl-5 border-bottom bg-light">
        <div class="row">
          <div class="col-4 py-3 font-weight-bold">
            Вопрос
          </div>

          <div class="col-8">
            <div class="row">
              <div class="col-4 border-left py-3 font-weight-bold">
                Ответ
              </div>

              <div class="col-4 border-left py-3 font-weight-bold">
                Комментарий клиента
              </div>
              <div class="col-4 border-left py-3 font-weight-bold">
                Комментарий врача
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="category in questionnaire.categories"
        :key="category.id">

        <QuestionnaireCategory
          :category="category"
          :mode="mode"
          :comment-answer="commentAnswer"
          :update-answer="updateAnswer"
          :userCanEdit="userCanEdit"
          :userCanComment="userCanComment" />
      </div>
    </div>

    <div class="border-left border-right mt-5">
      <div class="border-bottom border-top font-weight-bold bg-light py-3 px-3">
        Вопросы с ответами в красной зоне
      </div>

      <div
        v-for="question in danger"
        :key="`danger-${question.id}`"
        class="px-3">
        <a :href="`#${question.id}`">{{question.text}}</a>
      </div>
    </div>

    <div class="border-left border-right mb-5">
      <div class="border-bottom border-top font-weight-bold bg-light py-3 px-3">
        Вопросы с ответами в желтой зоне
      </div>

      <div
        v-for="question in warning"
        :key="`warning-${question.id}`"
        class="px-3">
        <a :href="`#${question.id}`">{{question.text}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import QuestionnaireCategory from './item/Category';

  export default {
    name: 'QuestionnaireItem',

    components: {QuestionnaireCategory},

    props: ['questionnaire', 'commentAnswer', 'updateAnswers', 'userCanEdit', 'userCanComment'],

    data() {
      return {
        selected: [],
        mode: 'normal',
        form: {},
        saving: false,
      };
    },

    computed: {
      danger() {
        const questions = [];

        for (const category of this.questionnaire.categories) {
          for (const question of category.questions) {
            const hasDangerAnswers = question.fields.find(f => {
              return typeof f.answer !== 'undefined' && f.level <= 20 && f.level > 0;
            });

            if (typeof hasDangerAnswers !== 'undefined') {
              questions.push(question);
            }
          }
        }

        return questions;
      },

      warning() {
        const questions = [];

        for (const category of this.questionnaire.categories) {
          for (const question of category.questions) {
            const hasWarningAnswers = question.fields.find(f => {
              return typeof f.answer !== 'undefined' && f.level <= 40 && f.level > 20;
            });

            if (typeof hasWarningAnswers !== 'undefined') {
              questions.push(question);
            }
          }
        }

        return questions;
      },
    },

    methods: {
      updateAnswer(fieldId, data) {
        if (typeof data === 'undefined' || data === null) {
          return delete this.form[fieldId];
        }

        const { value, comment } = data;

        this.form[fieldId] = { value, comment };
      },

      switchMode(mode) {
        this.mode = mode === 'edit' ? 'edit' : 'normal';
        this.form = {};

        for(const c of this.questionnaire.categories) {
          for(const q of c.questions) {
            for(const f of q.fields) {
              if (typeof f.answer !== 'undefined') {
                const { value, comment } = f.answer;

                this.form[f.id] = { value, comment };
              }
            }
          }
        }
      },

      async saveChanges() {
        this.saving = true;

        try {
          const answers = [];

          for (const field of Object.keys(this.form)) {
            const { value, comment } = this.form[field];

            answers.push({ field, value, comment });
          }

          await this.updateAnswers(this.questionnaire.id, answers);

          this.switchMode('normal');
        } catch (e) {
          //do-nothing
        }

        this.saving = false;
      },
    }
  };
</script>
